module.exports = __webpack_public_path__ + "img/25.e14e14a0.png";